export function StatusIndicator(gmtOffset, businessHoursStart, businessHoursEnd) {
  return {
    status: 'online',
    setAvailabilityStatus() {
      // Retrieve store's GMT offset and business hours (local to the store's time zone)
      const storeGmtOffset = parseInt(gmtOffset || 0, 10);

      const [openingHour = 0, openingMinutes = 0] = businessHoursStart.split(':').map(Number);
      const [closingHour = 0, closingMinutes = 0] = businessHoursEnd.split(':').map(Number);

      // Handle 24/7 availability
      const isAlwaysOpen =
        openingHour === 0 && openingMinutes === 0 && closingHour === 23 && closingMinutes === 59;
      if (isAlwaysOpen) {
        this.status = 'online';
        return;
      }

      // Get the user's current time zone offset in hours
      const userGmtOffset = -(new Date().getTimezoneOffset() / 60);

      // Calculate the difference between the user's GMT offset and the store's GMT offset
      const gmtDifference = userGmtOffset - storeGmtOffset;

      // Adjust store opening and closing hours to the user's local time
      const openingHourUserTime = (openingHour + gmtDifference + 24) % 24;
      const closingHourUserTime = (closingHour + gmtDifference + 24) % 24;

      const now = new Date();
      const currentHour = now.getHours();
      const currentMinutes = now.getMinutes();

      const currentTimeInMinutes = currentHour * 60 + currentMinutes;
      const openingTimeInMinutesUser = openingHourUserTime * 60 + openingMinutes;
      const closingTimeInMinutesUser = closingHourUserTime * 60 + closingMinutes;

      /**
       * First condition handles business hours on the same day
       * Second condition handles business hours past midnight (next day)
       */
      const isOpen =
        (closingHourUserTime > openingHourUserTime &&
          currentTimeInMinutes >= openingTimeInMinutesUser &&
          currentTimeInMinutes < closingTimeInMinutesUser) ||
        (closingHourUserTime < openingHourUserTime &&
          (currentTimeInMinutes >= openingTimeInMinutesUser ||
            currentTimeInMinutes < closingTimeInMinutesUser));

      this.status = isOpen ? 'online' : 'offline';
    },
  };
}
